<template>

    <Layout
        :header="{ text: titleText, backBtn: { visible: false }, closeBtn: { visible: true, to: { name: routeName.CLOUD_E_COUNTER_HOME } }, }">

        <div class="pt-2 pb-6">
            <Process :steps="['同意條款', '選擇保單', '確認資料', '手機驗證',]" :index="3"></Process>
        </div>

        <div class="pb-8">
            <h2 class="font-bold text-2xl pb-2">
                行動電話驗證
            </h2>
            <p>已發送動態密碼至您的行動電話 {{ maskMobile(otpMobile) }}</p>
            <p v-if="verifyErrorTimes" class="text-lg text-warning text-center mb-1">
                您輸入錯誤次數已{{ verifyErrorTimes }}次
            </p>

        </div>

        <div class="pb-2">
            <VerificationCode :isImmediate="true" buttonText="索取新動態密碼" :buttonDisabled="isCounting"
                :beginCounting="beginCounting" :stopCounting="stopCounting" :setData="(data) => { otpCodePre = data }"
                :reSendLimit="(data) => { countSendTimes(data) }">
                <span class="flex justify-between items-center pb-2">
                    <div class="flex pr-1 flex-shrink-0">
                        <p class="text-lg">{{ otpCodePre }} -</p>
                    </div><input type="text" placeholder="請輸入 6 碼動態密碼" maxlength="6" size="6" v-model="otpCode" />
                </span>
            </VerificationCode>
        </div>

        <ul class="list-decimal pb-2 pl-4 text-sm">
            <li class="pb-2">系統將於1~2分鐘內傳送動態密碼予您。</li>
            <li class="pb-2">請勿關閉此視窗，收到動態密碼後即刻進行認證。</li>
            <li class="pb-2">動態密碼發送後，需等待60秒方可索取新動態密碼。</li>
        </ul>

        <template v-slot:bottom>
            <button
                class="w-full pt-5 pb-14 text-center bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                :disabled="disableSubmitBtn" @click="goNextPage">確認</button>
        </template>

        <InfoBox v-if="errorBoxVisble" :closeHandel="closeBox" title="系統提示">
            <div v-html="errorMsg" />
        </InfoBox>

    </Layout>
</template>
<style scoped></style>


<script setup>
import '@/assets/cloudCounter/css/style.css';
import { ref, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import Layout from '@/components/cloudCounter/Layout.vue';
import InfoBox from '@/components/cloudCounter/InfoBox.vue'
import Process from '@/components/cloudCounter/Process.vue';
import VerificationCode from '@/components/cloudCounter/VerificationCode.vue';
import routeName from '@/router/constant.js';
import { getInfoOTP, postSentOTP, postVerifyOTP } from '@/apis/OTP';
import aplCatlCode from '@/json/aplCatlCode';
import { maskMobile } from '@/utils/maskUtils.js';

import { useRouter } from 'vue-router';
const router = useRouter();
const store = useStore();
const verifyErrorTimes = ref(0);
const sendTimes = ref(0);
const errorBoxVisble = ref(false);
const errorMsg = ref('');
const otpCode = ref('');
const otpCodePre = ref('');
const titleText = ref('');
const errorType = ref('');
const mobileNumber = reactive({
    old: '',
    lastNumber: ''
});
const otpMobile = ref('');

const aplCatl = computed(() => store.state.services.aplCatl);
if (aplCatl.value === aplCatlCode.BENEIFCIARY) {
    titleText.value = '受益人變更'
} else if (aplCatl.value === aplCatlCode.APPLICANT_CHANGE) {
    titleText.value = '要保人變更'
} else if (aplCatl.value === aplCatlCode.APPLICANT_INSURED_NAME_CHANGE) {
    titleText.value = '要保人或被保險人姓名變更'
} else if (aplCatl.value === aplCatlCode.LOAN) {
    titleText.value = '保單借款'
}

const disableSubmitBtn = computed(() => {
    return !/^\d{6}$/.test(otpCode.value)
})


const getData = () => {
    const forceSend = false; // default false
    postSentOTP(forceSend, otpMobile.value).then(res => {
        otpCodePre.value = res?.data?.otpCodePre;
    }).catch(err => {
        otpCodePre.value = err?.data?.otpCodePre;
    }).finally(() => {

    });

    console.log('111111');

    // isLoading.value = true;
    getInfoOTP().then((res) => {
        const { beforeMobile, mobile } = res.data;
        mobileNumber.old = beforeMobile;
        mobileNumber.lastNumber = mobile;
        //otpMobile.value = beforeMobile === '' && mobile;
        if (beforeMobile !== '' && mobile !== '' && beforeMobile !== mobile) {
            otpMobile.value = mobile;
        } else if (beforeMobile === '' && mobile) {
            otpMobile.value = mobile;
        } else {
            otpMobile.value = beforeMobile;
        }

        console.log(beforeMobile);
        console.log(beforeMobile === '');
        console.log(mobile);
        console.log('222222');
        console.log(otpMobile.value);
    }).finally(() => {

        // isLoading.value = false;
    });
};
getData();


const goNextPage = () => {

    if (!otpCode.value) {
        errorBoxVisble.value = true;
        errorMsg.value = '動態密碼未輸入，請確認！';
        return;
    } else {
        errorMsg.value = '';
    }

    // isSpin.value = true;
    postVerifyOTP(otpCode.value, otpMobile.value).then(res => {
        const { verify, cancelTransaction, errorTimes, notMeeting } = res.data;
        verifyErrorTimes.value = errorTimes;
        if (verify) {
            // 保單借款若不須視訊，走自己的申請完成頁
            if (notMeeting) {
                router.push({
                    name: routeName.CLOUD_E_COUNTER_LOAN_FINISH
                });
                return;
            }

            router.push({
                name: routeName.CLOUD_E_COUNTER_APPLY_FINISH
            });
        } else if (cancelTransaction) {
            errorMsg.value = `您的動態密碼已輸入錯誤達五次，請重新申請，謝謝！`;
            errorBoxVisble.value = true;
            errorType.value = 'STOP_PROCESS';
            return;
            // modalShow(dialogContnet.otpError5Times);
            // console.log(dialogContnet.otpError5Times);
        } else {
            otpCode.value = '';
            errorBoxVisble.value = true;
            errorMsg.value = '驗證碼錯誤';
            return;
        }
        setTimeout(() => {
            // isSpin.value = false;
        }, 1000);
    });
};

const countSendTimes = (data) => {
    if (data === 3) {
        errorMsg.value = `動態密碼重新補發已達三次，請輸入正確動態密碼或重新申請變更，謝謝!`;
        errorBoxVisble.value = true;
        stopCounting();
    }
}

const closeBox = () => {
    if (errorType.value === 'STOP_PROCESS') {
        router.push({ name: routeName.CLOUD_E_COUNTER_HOME });
    }
    errorBoxVisble.value = false;
}

//倒數中
const isCounting = ref(false);
const beginCounting = () => {
    isCounting.value = true;
    otpCode.value = '';
}
const stopCounting = () => {
    isCounting.value = false;
}

</script>
